import PropTypes from 'prop-types';
import { ThemeColorsPropType } from '../../common/ThemeColors.js';

/** @typedef {import('../../common/ThemeColors.js').ThemeColors} ThemeColors */

/**
 * @typedef {Object} ProductsContextType
 * @property {string=} logoUrl
 * @property {string=} promoHeader
 * @property {string=} introText
 * @property {string=} callToAction
 * @property {*} [footer]
 * @property {string[]=} productIds
 * @property {Map<string, any>=} prices
 * @property {Map<string, any>=} fetchedProducts
 * @property {boolean=} productsLoaded
 * @property {string=} qrUrl
 * @property {ThemeColors=} themeColors - dealer's theme colors
 */
export const ProductsContextType = PropTypes.shape({
  logoUrl: PropTypes.string,
  promoHeader: PropTypes.string,
  introText: PropTypes.string,
  callToAction: PropTypes.string,
  footer: PropTypes.any, // passed through to EFlyerFooter
  productIds: PropTypes.arrayOf(PropTypes.string),
  prices: PropTypes.instanceOf(Map),
  fetchedProducts: PropTypes.instanceOf(Map),
  productsLoaded: PropTypes.bool,
  qrUrl: PropTypes.string,
  themeColors: ThemeColorsPropType
});
